import { Box } from '@chakra-ui/react/box';
import { Separator } from '@chakra-ui/react/separator';
import { Children, Fragment, isValidElement, PropsWithChildren, ReactElement } from 'react';

const DividedInfoItems = ({ children, skip }: PropsWithChildren<{ skip?: ReactElement['type'][] }>) => {
  return (
    <Box display="flex" alignItems="center" gap="12">
      {Children.map(children, (child, index) => {
        if (!isValidElement(child) || !child) return null;

        const isFirstChild = index === 0;
        const shouldSkipDivider = skip?.includes(child.type);
        const shouldRenderDivider = !isFirstChild && !shouldSkipDivider;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`item-${index}`}>
            {shouldRenderDivider && <Separator orientation="vertical" height="24" borderColor="border/minimal" />}
            {child}
          </Fragment>
        );
      })}
    </Box>
  );
};

export default DividedInfoItems;
